const searchBtnADA = setInterval(() => {
    const searchBtn = document.querySelector(".aa-SubmitButton");
    if(searchBtn) {
        searchBtn.setAttribute("aria-label", "Submit search");
        clearInterval(searchBtnADA);
    }
}, 1000);

const accessibeADA = setInterval(() => {
    const accessibe = document.querySelector("a.acsb-sr-only");
    if(accessibe) {
        accessibe.setAttribute("aria-label", "")
    }
}, 1000);

const start = Date.now();
while (Date.now() - start < 1500) {}